import { FC } from "react";

import CustomLink from "@Components/CustomLink";
import wrapperHOC from "@Utils/wrapperHOC";
import {
  APP_DOWNLOAD_APP_STORE_LINK,
  APP_DOWNLOAD_PLAY_STORE_LINK,
} from "constants/configConstants";

import styles from "./StoreButtons.module.scss";

/**
 * The footer's app download on a phone: the two store badges, side by side, in place of
 * the desktop's QR card — a visitor holding the phone has nothing to scan it with.
 */
const StoreButtons: FC<{ onClick: (store: string) => void }> = ({ onClick }) => (
  <div className={styles.stores}>
    <CustomLink
      href={APP_DOWNLOAD_APP_STORE_LINK}
      target="_blank"
      rel="noreferrer"
      isExternal
      className={styles.store}
      dataTestId="v2-footer-app-store"
      onClick={() => onClick("App Store")}
    >
      <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
        <path
          fill="currentColor"
          d="M16.37 1.43c0 1.14-.49 2.27-1.18 3.08-.74.9-1.99 1.57-2.99 1.57-.12 0-.23-.02-.3-.03-.01-.06-.04-.22-.04-.39 0-1.15.57-2.27 1.21-2.98.8-.94 2.14-1.64 3.25-1.68.03.13.05.28.05.43zm4.56 15.71c-.03.07-.46 1.58-1.52 3.12-.94 1.34-1.94 2.71-3.43 2.71-1.52 0-1.9-.88-3.63-.88-1.7 0-2.3.91-3.67.91-1.38 0-2.33-1.26-3.43-2.8-1.29-1.82-2.32-4.63-2.32-7.28 0-4.28 2.8-6.55 5.55-6.55 1.45 0 2.68.95 3.6.95.87 0 2.22-1.01 3.9-1.01.61 0 2.89.06 4.37 2.19-.13.09-2.38 1.37-2.38 4.19 0 3.26 2.85 4.42 2.96 4.45z"
        />
      </svg>
      <span className={styles.text}>
        <span className={styles.small}>Download on the</span>
        <span className={styles.big}>App Store</span>
      </span>
    </CustomLink>

    <CustomLink
      href={APP_DOWNLOAD_PLAY_STORE_LINK}
      target="_blank"
      rel="noreferrer"
      isExternal
      className={styles.store}
      dataTestId="v2-footer-play-store"
      onClick={() => onClick("Google Play")}
    >
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <path
          fill="#00d7fe"
          d="M3.6 1.8 13.5 12 3.6 22.2c-.37-.2-.6-.6-.6-1.1V2.9c0-.5.23-.9.6-1.1z"
        />
        <path fill="#ffce00" d="M17 8.4 13.5 12l3.5 3.6 4-2.3c1.1-.6 1.1-2 0-2.6z" />
        <path fill="#ff3a44" d="M13.5 12 3.6 22.2c.37.2.85.2 1.3-.05L17 15.6z" />
        <path fill="#00f076" d="M13.5 12 17 8.4 4.9 1.85c-.45-.25-.93-.25-1.3-.05z" />
      </svg>
      <span className={styles.text}>
        <span className={styles.small}>GET IT ON</span>
        <span className={styles.big}>Google Play</span>
      </span>
    </CustomLink>
  </div>
);

export default wrapperHOC(StoreButtons, {
  componentName: "HomeV3-StoreButtons",
  showForChina: true,
  showForWhiteLable: false,
});
